// GENERATED by scripts/buildAboutMarkerMap.js — do not edit by hand.
// Section enum value -> PanelField id -> About categoryId. Lets the About
// tab resolve a marker's description by stable categoryId, so sheet title
// edits never break the lookup. Regenerate after adding/renumbering markers.
export const ABOUT_MARKER_MAP: { [section: string]: { [fieldId: string]: number } } = {
  "Electrolytes": {
    "anionGap": 700730,
    "anionGapWithoutK": 700725,
    "carbonDioxide": 700720,
    "chloride": 700715,
    "potassium": 700705,
    "sodium": 700700,
    "sodiumPotassiumRatio": 700710,
  },
  "Glucose": {
    "amylase": 700355,
    "cpeptide": 700335,
    "glucose": 700320,
    "hdl": 700350,
    "hemoglobinA1c": 700325,
    "insulin": 700330,
    "triglycerides": 700345,
    "triglyceridesHDLRatio": 700340,
  },
  "Hormones": {
    "antiMullerianHormone": 701200,
    "cortisolAM": 701205,
    "cortisolPM": 701210,
    "dheaS": 701215,
    "dihydrotestosterone": 701220,
    "estradiolE2": 701225,
    "estriolE3": 701230,
    "estrogensTotal": 701235,
    "estroneE1": 701240,
    "fsh": 701245,
    "hCG": 701250,
    "hydroxyprogesterone17": 701275,
    "igf1": 701255,
    "lh": 701260,
    "pregnenolone": 701265,
    "progesterone": 701270,
    "prolactin": 701280,
    "prolactinLactating": 701285,
    "shbg": 701290,
    "testosteroneBioavailable": 701295,
    "testosteroneBioavailablePercent": 701300,
    "testosteroneFreeCalc": 701305,
    "testosteroneFreeDirect": 701310,
    "testosteroneTotal": 701315,
    "testosteroneTotalLCMS": 701320,
  },
  "Inflammation / Oxidative Stress": {
    "albumin": 701000,
    "bilirubin": 701005,
    "ceruloplasmin": 701010,
    "esr": 701045,
    "ferritin": 701015,
    "fibrinogen": 701020,
    "ggt": 701025,
    "hdl": 701030,
    "homocysteine": 701035,
    "hsCRP": 701040,
    "tibc": 701050,
    "transferrin": 701055,
    "uricAcid": 701060,
  },
  "Iron": {
    "ceruloplasmin": 700125,
    "copperRBCμgdL": 700130,
    "copperRBCμgmL": 700130,
    "copperSerummcgmL": 700135,
    "copperSerumμgdL": 700135,
    "ferritin": 700115,
    "iron": 700100,
    "percentOfFreeCopper": 700140,
    "saturation": 700110,
    "tibc": 700105,
    "transferrin": 700120,
    "vitaminA": 700145,
  },
  "Kidney": {
    "bun": 700400,
    "bunCreatinineRatio": 700415,
    "creatinine": 700405,
    "eGFR": 700410,
    "uricAcid": 700420,
  },
  "Lipids": {
    "apoBapoA1Ratio": 700940,
    "apolipoproteinA1": 700930,
    "apolipoproteinB": 700935,
    "cholesterol": 700900,
    "cholesterolHDLRatio": 700920,
    "hdl": 700910,
    "ldl": 700915,
    "lipoproteinA": 700945,
    "triglycerides": 700905,
    "triglyceridesHDLRatio": 700925,
  },
  "Liver / Biliary": {
    "alkalinePhosphatase": 700820,
    "alt": 700830,
    "ast": 700825,
    "bileAcids": 700800,
    "bilirubin": 700805,
    "bilirubinDirect": 700810,
    "bilirubinIndirect": 700815,
    "ggt": 700835,
    "lactateDehydrogenase": 700840,
  },
  "Nutrients": {
    "calcium": 700600,
    "ceruloplasmin": 700605,
    "copperRBCμgdL": 700610,
    "copperRBCμgmL": 700610,
    "copperSerummcgmL": 700615,
    "copperSerumμgdL": 700615,
    "copperZincRatio": 700620,
    "folateRBC": 700630,
    "folateSerum": 700635,
    "magnesium": 700645,
    "magnesiumRBC": 700640,
    "percentOfFreeCopper": 700625,
    "phosphorus": 700650,
    "vitaminA": 700655,
    "vitaminB12": 700665,
    "vitaminB6": 700660,
    "vitaminD": 700670,
    "vitaminD125": 700675,
    "zincRBCmgL": 700680,
    "zincRBCμgdL": 700680,
    "zincSerummcgmL": 700685,
    "zincSerumμgdL": 700685,
  },
  "Platelets": {
    "dDimer": 700310,
    "fibrinogen": 700315,
    "meanPlateletVolume": 700305,
    "plateletCount": 700300,
    "viscosityCapiliaries": 700316,
  },
  "Prostate": {
    "psaFree": 701330,
    "psaFreePercent": 701335,
    "psaTotal": 701325,
  },
  "Proteins": {
    "albumin": 700505,
    "albuminGlobulinRatio": 700515,
    "globulin": 700510,
    "protein": 700500,
  },
  "RBC": {
    "RPI": 700040,
    "hematocrit": 700010,
    "hemoglobin": 700005,
    "mchConcentration": 700025,
    "meanCorpuscularHGB": 700020,
    "meanCorpuscularVolume": 700015,
    "rbcDistributionWidth": 700030,
    "redBloodCells": 700000,
    "reticulocyteCount": 700035,
  },
  "Stress & Adrenal Balance": {
    "cortisolAM": 701415,
    "cortisolPM": 701420,
    "dheaS": 701425,
    "potassium": 701410,
    "pregnenolone": 701430,
    "sodium": 701405,
    "sodiumPotassiumRatio": 701400,
  },
  "Thyroid": {
    "freeT4Index": 701150,
    "reverseT3": 701125,
    "t3Free": 701120,
    "t3Total": 701115,
    "t3Uptake": 701145,
    "t4Free": 701110,
    "t4Total": 701105,
    "tbg": 701140,
    "tgAb": 701135,
    "tpoAb": 701130,
    "tsh": 701100,
  },
  "WBC": {
    "alkalinePhosphatase": 700265,
    "basophils": 700225,
    "basophilsAbsolute": 700250,
    "eosinophils": 700220,
    "eosinophilsAbsolute": 700245,
    "globulin": 700260,
    "lymphocytes": 700210,
    "lymphocytesAbsolute": 700235,
    "monocytes": 700215,
    "monocytesAbsolute": 700240,
    "neutrophils": 700205,
    "neutrophilsAbsolute": 700230,
    "nlr": 700255,
    "whiteBloodCells": 700200,
  },
};
